import * as Sentry from '@sentry/react';
import { reportUnlessExpected } from './reportUnlessExpected.ts';

/**
 * React reports an error a boundary caught only to the root callbacks, never to
 * the global handlers Sentry hooks. Passed to `createRoot`, with the console
 * line React would otherwise own, so a crashed page still reaches Sentry.
 */
export function sentryRootErrorHandlers() {
  return {
    onUncaughtError: reportUnlessExpected(Sentry.reactErrorHandler()),
    onCaughtError: reportUnlessExpected(
      Sentry.reactErrorHandler((error, errorInfo) => {
        console.error('Caught error', error, errorInfo.componentStack);
      }),
    ),
  };
}
